const styles = (theme) => ({
    visibility: {
        cursor: 'pointer',
    },
});

export default styles;
